module.exports = __webpack_public_path__ + "img/ic_4.59cef50d.png";